import { render } from "./AppHeader.vue?vue&type=template&id=647f2169"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/wavemobile.de/wavemobile/FE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__